import { useUserDownline } from 'features/downline-explorer/hooks/useUserDownline';
import { Icon, IconName } from 'libs/icons';
import { useTranslation } from 'libs/translations';
import _ from 'lodash';
// eslint-disable-next-line no-restricted-imports
import { MdOutlineSubdirectoryArrowRight } from 'react-icons/md';

import { UserProfileWithStructure } from '../types';

interface IActionsCellRendererProps {
  readonly user: UserProfileWithStructure;
  readonly onExploreDownline?: (userId: string) => void;
}

export function ActionsCellRenderer({ user }: IActionsCellRendererProps) {
  const { t } = useTranslation();
  const { goToUserDownline } = useUserDownline();

  const hasDownline = user.hasDownline && _.isUndefined(user.countryUserId);
  const isActionable = user.structureType !== 'selectedUser' && hasDownline;

  const handleExploreDownlineClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    event.stopPropagation();
    goToUserDownline(user.userId);
  };

  const renderIcon = () => {
    if (user.structureType !== 'downline') {
      return <MdOutlineSubdirectoryArrowRight size={16} />;
    }

    if (hasDownline) {
      return <Icon name={IconName.PlusSign} size={16} />;
    }

    return null;
  };

  if (isActionable) {
    return (
      <button
        title={t('Explore Downline')}
        onClick={handleExploreDownlineClick}
        className="explore-downline-button flex justify-between items-center p-3"
        aria-label={t("Explore {{userName}}'s Downline", {
          userName: user.name
        })}
      >
        {renderIcon()}
      </button>
    );
  }

  return (
    <div className="flex justify-between items-center p-3 text-activeDisabled">
      {renderIcon()}
    </div>
  );
}
